import HomeIcon from "@/images/navbar/home-icon.svg";
import OfficeIcon from "@/images/navbar/office-icon.svg";
import LifestyleIcon from "@/images/navbar/lifestyle-icon.svg";
import LocationIcon from "@/images/navbar/location-icon.svg";
import GalleryIcon from "@/images/navbar/gallery-icon.svg";
import LeasingIcon from "@/images/navbar/leasing-icon.svg";
import FilmIcon from "@/images/navbar/film-icon.svg";

export const MENU_ITEMS = [
  {
    label: "Home",
    icon: HomeIcon,
    link: "/"
  },
  {
    label: "Office",
    icon: OfficeIcon,
    link: "/office",
    containerStyle: {},
    iconStyle: { paddingTop: 2 }
  },
  {
    label: "Lifestyle",
    icon: LifestyleIcon,
    link: "/lifestyle",
    containerStyle: {},
    iconStyle: {}
  },
  {
    label: "Location",
    icon: LocationIcon,
    link: "/location",
    containerStyle: {},
    iconStyle: {}
  },
  {
    label: "Gallery",
    icon: GalleryIcon,
    link: "/gallery",
    containerStyle: {},
    iconStyle: {}
  },
  {
    label: "Leasing",
    icon: LeasingIcon,
    link: "/leasing",
    containerStyle: {},
    iconStyle: { paddingLeft: 2 }
  },
  {
    label: "Film",
    icon: FilmIcon,
    link: "/film",
    containerStyle: {},
    iconStyle: {}
  }
];

export default {};
